import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ComponentStatus, StateComponent } from '../../../../../common/components/state/state.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CompetitionGroupCommonService } from '../common/services/competition-group-common.service';
import { IFormModel } from '../../../../../common/apis/form/model/form.model';
import { MatDialog } from '@angular/material/dialog';
import { FormSubmissionStatusDialogComponent, FormSubmissionStatusDialogComponentData } from './form-submission-status-dialog/form-submission-status-dialog.component';
import { NotificationService } from '../../../../../common/services/notification.service';
import { AnalyticsService } from '../../../../../common/services/analytics.service';
import { ICompetitionGroupModel } from '../../../../../common/apis/competition-group/model/competitoin-group.model';
import { FormBettingApiService } from '../../../../../common/apis/form/form-betting-api.service';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatListItem, MatListItemIcon, MatListItemLine, MatListItemTitle, MatNavList } from '@angular/material/list';
import { DatePipe } from '@angular/common';
import { MatCard, MatCardContent } from '@angular/material/card';
import { ListHeaderComponent } from '../../../../../common/components/list-header/list-header.component';
import { LoadingContainerComponent } from '../../../../../common/components/loading-container/loading-container.component';

@Component({
  selector: 'oo-group-forms-list',
  templateUrl: './group-forms-list.component.html',
  styleUrls: ['./group-forms-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LoadingContainerComponent,
    ListHeaderComponent,
    MatCard,
    MatCardContent,
    MatNavList,
    MatListItem,
    RouterLink,
    MatIcon,
    MatListItemIcon,
    MatListItemTitle,
    MatListItemLine,
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    DatePipe,
  ],
})
export class GroupFormsListComponent extends StateComponent<FormsListComponentState> implements OnInit {

  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly formApi = inject(FormBettingApiService);
  private readonly competitionGroupCommonService = inject(CompetitionGroupCommonService);
  state: FormsListComponentState = {
    status: 'ready',
    competitionGroup: this.competitionGroupCommonService.getCompGroupInfo(this.route.snapshot.parent!.paramMap.get('compGroupId')!),
    forms: [],
  };
  private readonly dialog = inject(MatDialog);
  private readonly notificationService = inject(NotificationService);
  private readonly analyticsService = inject(AnalyticsService);

  ngOnInit(): void {
    this.analyticsService.trackScreenName('formsList');
    this.fetchData();
  }

  getFormIcon(form: IFormModel): string {
    if (form.hasBettingResult) {
      return 'done_all';
    }

    if (form.userBettingId) {
      return 'done';
    } else if (form.startsAt <= new Date()) {
      return 'warning';
    }

    return 'error';
  }

  getCurrentDate(): Date {
    return new Date();
  }

  openStatusDialog(form: IFormModel): void {
    this.dialog.open(FormSubmissionStatusDialogComponent, {
      data: {
        formId: form.id,
        compGroupId: this.state.competitionGroup.id,
      } as FormSubmissionStatusDialogComponentData,
    });
  }

  onFormItemClick(form: IFormModel): void {
    if (form.hasBettingResult || form.startsAt < this.getCurrentDate()) {
      this.router.navigate(['../formResults', form.id], { relativeTo: this.route });
    } else {
      this.router.navigate(['../formBetting', form.id], { relativeTo: this.route });
    }
  }

  private fetchData(): void {
    this.updateStatus('loading');
    this.formApi.getForms(this.state.competitionGroup.id, ['userBettingId', 'hasBettingResult'])
      .then((forms) => {
        this.updateState(
          {
            status: 'ready',
            forms: forms.sort((a, b) => a.startsAt < b.startsAt ? 1 : -1),
          },
        );
      })
      .catch((e: Error) => {
        console.error(e);
        this.updateStatus('error');
      });
  }
}

interface FormsListComponentState {
  status: ComponentStatus;
  competitionGroup: ICompetitionGroupModel;
  forms: IFormModel[];
}
